import * as React from 'react';

// @ts-ignore
import AdminStatisticsCommunicationChart from 'admin/components/AdminStatisticsCommunicationChart';
// @ts-ignore
import AdminStatisticsReachChart from 'admin/components/AdminStatisticsReachChart';
// @ts-ignore
import { formatData } from 'admin/lib/Chart';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';
// @ts-ignore
import remindWwwRequest from 'lib/remindWwwRequest';

import { School, Stats } from 'admin/components/AdminUpgradeStats';

import './AdminUpgradeStats.scss';

const CHART_HEIGHT = 200;

type AdminUpgradeStatsChartFigureProps = {
  caption: string;
  children: React.ReactNode;
  title: string;
};

function AdminUpgradeStatsChartFigure({
  caption,
  children,
  title,
}: AdminUpgradeStatsChartFigureProps) {
  return (
    <figure className="AdminUpgradeStats-chartFigure">
      <Heading level="3" levelStyle="4">
        {title}
      </Heading>
      <Row>
        <Text color="thunder">{children}</Text>
      </Row>
      <Text align="left" element="figcaption" size="xsmall">
        {caption}
      </Text>
    </figure>
  );
}

type Props = {
  school: School;
  stats: Stats;
};

export default function AdminUpgradeStats({ school, stats }: Props) {
  if (!school || !stats) {
    return null;
  }

  const {
    messaging_users_count: activeUsersCount,
    org_name: name,
    school_pages_equivalent_grade: gradeLevel,
  } = school;

  const isHighSchool = gradeLevel === 'high_school';

  return (
    <Box
      title={
        <React.Fragment>
          Remind usage at
          <br /> <b>{name}</b>
        </React.Fragment>
      }
      subtext={
        <React.Fragment>
          <b>{activeUsersCount}</b>{' '}
          {activeUsersCount === 1 ? (
            <React.Fragment>teacher, student, or parent is</React.Fragment>
          ) : (
              <React.Fragment>teachers, students, and parents are</React.Fragment>
            )}{' '}
          actively communicating on Remind.
        </React.Fragment>
      }
      className="AdminUpgradeStats">
      <BoxBody size="small">
        <Row size="xxxxxlarge">
          <AdminUpgradeStatsChartFigure
            title="Messages delivered"
            caption="Most engagement in a school community occurs at the classroom level. This
              includes class updates and two-way communication between teachers and families.">
            <AdminStatisticsCommunicationChart
              data={formatData(stats.communication_usage.chart, 'month')}
              height={CHART_HEIGHT}
              simple
              tooltip
            />
          </AdminUpgradeStatsChartFigure>
        </Row>
        <AdminUpgradeStatsChartFigure
          title={isHighSchool ? 'Parents and students reached' : 'Parents reached'}
          caption="The reach of a school community is determined by access to effective
            communication channels and how frequently teachers communicate with students and
            parents.">
          <AdminStatisticsReachChart
            data={formatData(stats.reach_usage.chart, 'month')}
            height={CHART_HEIGHT}
            simple
            students={isHighSchool}
            teachers={false}
            tooltip
          />
        </AdminUpgradeStatsChartFigure>
      </BoxBody>
    </Box>
  );
}
